import { render, staticRenderFns } from "./JobMetrics.vue?vue&type=template&id=e878f504&"
import script from "./JobMetrics.vue?vue&type=script&lang=js&"
export * from "./JobMetrics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports